import { z } from "zod";
import {
  FactNodeSchema,
  type FactEdgeMetadata,
  type FactNodeContent,
} from "./FactNode.js";
import {
  NoteFactNodeContentSchema,
  NoteOnPersonFactEdgeMetadataSchema,
} from "./FactNodes/NoteFactNode.js";

export const noteBodyMaxLength =
  NoteFactNodeContentSchema.shape.body.maxLength ?? 256;

export const noteTitleMaxLength =
  NoteFactNodeContentSchema.shape.title.unwrap().maxLength ?? 120;

export const noteMetadata = {
  nodeType: NoteFactNodeContentSchema.shape.nodeType.value,
  nodeVersion: NoteFactNodeContentSchema.shape.version.value,
  noteOnPersonEdgeType: NoteOnPersonFactEdgeMetadataSchema.shape.edgeType.value,
  noteOnPersonEdgeVersion:
    NoteOnPersonFactEdgeMetadataSchema.shape.version.value,
};

export const NoteV2Schema = z.object({
  ...FactNodeSchema.shape,
  content: NoteFactNodeContentSchema,
});

export const FilterNoteV2ParamsSchema = z.object({
  includePrivate: z.boolean().optional(),
  skip: z.int().optional(),
  take: z.int().max(100).optional(),
});

export type NoteV2 = z.infer<typeof NoteV2Schema>;
export type NoteContentV2 = Extract<FactNodeContent, { nodeType: "note" }>;
export type NoteV2NoteOnPersonMetadata = Extract<
  FactEdgeMetadata,
  { edgeType: "noteOnPerson" }
>;
export type FilterNoteV2Params = z.infer<typeof FilterNoteV2ParamsSchema>;
